import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import setAttendeeName from '@shoflo/studio-redux/actions/attendee/setAttendeeName';
import startProgram from '@shoflo/studio-redux/actions/program/startProgram';
import { SOURCE_ROLE_HOST } from '@studio/constants/Sources';
import { VENDOR_CHIME } from '@studio/constants/Vendor';
import {
  getAttendeeCameraSources,
  getDefaultSource
} from '../utils/broadcastSourceHelper';
import createLocalCameraSource from '../actions/Broadcast/sources/createLocalCameraSource';
import updatePresenterSettings from '../actions/Broadcast/presenters/updatePresenterSettings';
import { BROADCAST_CREATE_MEETING } from '../actions/Types';
import { shouldHaveFeature } from '@studio/feature.flags/featureFlags';

/**
 * Create a meeting for the host after they click the Join button
 * Join the meeting
 *
 * @param store
 */
export const joinMeeting = store => next => async action => {
  const { dispatch, getState } = store;

  const targetdActions = [`${BROADCAST_CREATE_MEETING}_SUCCESS`];

  from([action])
    .pipe(filter($action => targetdActions.includes($action.type)))
    .subscribe(async $action => {
      const meetingType = shouldHaveFeature('studio.meetingVendor');
      const isChimeMeeting = [VENDOR_CHIME, null, false, '', 'false'].includes(
        meetingType
      );

      const { broadcast, broadcastSources, attendeeRoster } = getState();
      if (!$action.payload.settings || !isChimeMeeting) return;
      const {
        audioInputDeviceId,
        audioOutputDeviceId,
        presenterTitle,
        presenterDescription,
        videoInput
      } = $action.payload.settings;

      const { sources } = broadcastSources;
      const {
        attendeeResponse,
        attendeesList,
        meetingResponse,
        meetingSession
      } = $action.payload;
      const { AttendeeId: attendeeId } = attendeeResponse.Attendee;

      dispatch(
        setAttendeeName(attendeeId, presenterTitle, '', SOURCE_ROLE_HOST)
      );

      sources.forEach(source => {
        if (source.type === 'cameraPresenter') {
          dispatch(
            setAttendeeName(
              source.value,
              source.title,
              source?.photo,
              source?.role
            )
          );
        }
      });

      const unassignedSources = getAttendeeCameraSources(
        sources,
        attendeeResponse,
        attendeesList,
        broadcast
      );
      const defaultSelectedSourceId = getDefaultSource(
        attendeeResponse,
        attendeeRoster,
        unassignedSources
      );

      // Start Program
      // This also tells NotificationButton that the Director has joined
      // and is ok to display knock notifications when they arrive.
      dispatch(startProgram());
      // Create local camera source
      dispatch(
        createLocalCameraSource(
          {
            videoInputDeviceId: videoInput,
            audioInputDeviceId,
            audioOutputDeviceId,
            meeting: { attendeeResponse, meetingResponse, meetingSession }
          },
          defaultSelectedSourceId,
          presenterDescription
        )
      );

      if (defaultSelectedSourceId) {
        const selectedSource = sources.find(
          source => source._id === defaultSelectedSourceId
        );
        dispatch(
          updatePresenterSettings(selectedSource, {
            source_title: presenterTitle,
            description: presenterDescription
          })
        );
      }
    });
  return next(action);
};

export default joinMeeting;
